(() => {
  const STORAGE_KEY = 'laia_cookie_consent_v2';
  const COOKIE_KEY = 'laia_cookie_consent_v2';
  const CONSENT_MAX_AGE = 60 * 60 * 24 * 180;
  const root = document.querySelector('[data-cookie-consent]');
  const settingsTrigger = document.querySelector('[data-cookie-settings-trigger]');
  if (!root || !settingsTrigger || !window.Shopify) return;

  const summary = root.querySelector('[data-cookie-summary]');
  const preferences = root.querySelector('[data-cookie-preferences]');
  const checkboxes = [...root.querySelectorAll('[data-cookie-preference]')];
  let returnFocus = null;

  const readStoredConsent = () => {
    try {
      const localValue = window.localStorage.getItem(STORAGE_KEY);
      if (localValue) return JSON.parse(localValue);
    } catch (error) {
      // Cookies remain the fallback when local storage is unavailable.
    }

    const cookieValue = document.cookie
      .split('; ')
      .find((entry) => entry.startsWith(`${COOKIE_KEY}=`))
      ?.split('=')
      .slice(1)
      .join('=');

    if (!cookieValue) return null;
    try {
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch (error) {
      return null;
    }
  };

  const storeConsent = (choices) => {
    const record = { ...choices, savedAt: new Date().toISOString() };
    const serialized = JSON.stringify(record);
    try {
      window.localStorage.setItem(STORAGE_KEY, serialized);
    } catch (error) {
      // The first-party cookie below is sufficient on its own.
    }
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(serialized)}; Path=/; Max-Age=${CONSENT_MAX_AGE}; SameSite=Lax${secure}`;
  };

  const consentValue = (value) => value === 'yes' || value === true;

  const currentConsent = () => {
    if (!window.Shopify.customerPrivacy) return {};
    return window.Shopify.customerPrivacy.currentVisitorConsent();
  };

  const syncCheckboxes = () => {
    const consent = currentConsent();
    checkboxes.forEach((checkbox) => {
      checkbox.checked = consentValue(consent[checkbox.dataset.cookiePreference]);
    });
  };

  const open = (showPreferences = false) => {
    returnFocus = document.activeElement;
    root.hidden = false;
    summary.hidden = showPreferences;
    preferences.hidden = !showPreferences;
    if (showPreferences) syncCheckboxes();
    document.documentElement.classList.add('laia-cookie-open');
    requestAnimationFrame(() => {
      root.querySelector(showPreferences ? '[data-cookie-save]' : '[data-cookie-accept]')?.focus();
    });
  };

  const close = () => {
    root.hidden = true;
    document.documentElement.classList.remove('laia-cookie-open');
    settingsTrigger.hidden = false;
    returnFocus?.focus();
  };

  const save = (choices, persist = true) => {
    window.Shopify.customerPrivacy.setTrackingConsent(choices, () => {
      if (persist) storeConsent(choices);
      close();
      document.dispatchEvent(new CustomEvent('laia:cookie-consent-updated', { detail: choices }));
    });
  };

  root.addEventListener('click', (event) => {
    const target = event.target.closest('button, [data-cookie-close]');
    if (!target) return;

    if (target.matches('[data-cookie-accept]')) {
      save({ analytics: true, marketing: true, preferences: true });
    } else if (target.matches('[data-cookie-reject]')) {
      save({ analytics: false, marketing: false, preferences: false });
    } else if (target.matches('[data-cookie-save]')) {
      const choices = Object.fromEntries(
        checkboxes.map((checkbox) => [checkbox.dataset.cookiePreference, checkbox.checked])
      );
      save(choices);
    } else if (target.matches('[data-cookie-open-preferences]')) {
      summary.hidden = true;
      preferences.hidden = false;
      syncCheckboxes();
      root.querySelector('[data-cookie-save]')?.focus();
    } else if (target.matches('[data-cookie-close]')) {
      close();
    }
  });

  settingsTrigger.addEventListener('click', () => open(true));

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      settingsTrigger.hidden = false;
      const stored = readStoredConsent();
      if (stored) {
        save({
          analytics: Boolean(stored.analytics),
          marketing: Boolean(stored.marketing),
          preferences: Boolean(stored.preferences)
        }, false);
        return;
      }
      if (window.Shopify.customerPrivacy.shouldShowBanner()) open(false);
    }
  );
})();
